var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"num-comp"},[_c('span',{staticClass:"num-span din"},[_vm._v(" "+_vm._s(_vm.number)+"% ")]),_c('span',{staticClass:"label-span"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }